import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BOOK_FEATURE_KEY, BookState, bookAdapter } from './book.reducer';
import {
  selectRouteNestedParam,
  selectRouteNestedParams,
} from '@lyceo/shared/data-access';
import { CallState, getError, LoadingState } from '@lyceo/shared/util-loading';

export const selectBookState =
  createFeatureSelector<BookState>(BOOK_FEATURE_KEY);

const { selectAll, selectEntities } = bookAdapter.getSelectors();

export const selectAllBooks = createSelector(
  selectBookState,
  (state: BookState) => selectAll(state),
);

export const selectBookEntities = createSelector(
  selectBookState,
  selectEntities,
);

export const selectParamBook = createSelector(
  selectBookEntities,
  selectRouteNestedParams,
  (books, { bookId }) => books[bookId],
);

export const selectBookFullyLoadedIds = createSelector(
  selectBookState,
  (state: BookState) => state.fullyLoadedIds,
);

export const selectParamBookId = selectRouteNestedParam('bookId');

export const selectParamBookLoaded = createSelector(
  selectParamBookId,
  selectBookFullyLoadedIds,
  (paramBookId, fullyLoadedIds) =>
    paramBookId ? fullyLoadedIds.includes(paramBookId) : false,
);

export const selectTocBookCallState = createSelector(
  selectBookState,
  (state) => state.tocCallState,
);

export const selectTocBookLoading = createSelector(
  selectTocBookCallState,
  (callState: CallState) => callState === LoadingState.LOADING,
);

export const selectTocBookError = createSelector(
  selectTocBookCallState,
  (callState: CallState) => getError(callState),
);

export const selectParamFinalExam = createSelector(
  selectParamBook,
  (book) => book?.finalExam,
);

export const selectParamFinalExamQuestionnaireId = createSelector(
  selectParamFinalExam,
  (finalExam) => finalExam?.questionnaireId,
);
